import React, { useEffect, useRef, useState } from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";

import {getCommonVisualizerType} from "../../../../config";

const loadingTime = 240000; // 4 minutes
// const loadingTime = 30000; // 30 sec

const loadingPhrases = [
  "uploadingYourKitchenPhoto",
  "analyzingLayoutAndLighting",
  "mappingCabinetsAndCounters",
  "tryingCabinetColors",
  "testingCountertopFinishes",
  "exploringBacksplashIdeas",
  "swappingHardwareStyles",
  "previewingFlooringOptions",
  "repositioningAppliancesVirtually",
  "settingMoodLighting",
  "clearingCountertopClutter",
  "stylingShelvesAndDecor",
  "paintingWallsVirtually",
  "addingIslandOptions",
  "checkingWorkTriangleFlow",
  "mixingMaterialsAndTextures",
  "polishingDetailsAndEdges",
  "renderingYourPreview",
  "applyingFinalTouchUps",
  "servingYourRedesignedKitchen",
];

const loadingPhrasesBathroom = [
  "uploadingYourKitchenPhoto", // +
  "analyzingLayoutAndLighting",
  "mappingVanityTubAndShower",
  "tryingVanityColors",
  "testingCountertopAndSinkFinishes",
  "exploringTilePatterns",
  "swappingFaucetAndHardwareStyles",
  "previewingFloorTileOptions",
  "repositioningFixturesVirtually",
  "settingVanityAndAmbientLighting",
  "clearingCounterAndShowerClutter",
  "stylingShelvesMirrorsAndDecor",
  "paintingWallsVirtually", // +
  "addingStorageSolutions",
  "checkingClearancesAndTrafficFlow",
  "mixingMaterialsAndTextures",
  "polishingGroutLinesAndEdges",
  "renderingYourPreview", // +
  "applyingFinalTouchUps", // +
  "revealingYourRedesignedBathroom",
];

const stepMs =  Math.floor(loadingTime / loadingPhrases.length);
// const clamp = (n, min, max) => Math.min(max, Math.max(min, n));


const LookAILoadingBar = ({aiLoading, className, intl, language}) => {

  const [phraseIndex, setPhraseIndex] = useState(0);
  const [transition, setTransition] = useState(false);
  const [progress, setProgress] = useState(0); // 0..100

  // const startedAtRef = useRef(null);
  // const rafRef = useRef(null);
  const stepTimerRef = useRef(null);

  useEffect(() => {

    if (!aiLoading) {
      // When we finish, instantly complete the bar and stop timers.
      // cancelAnimationFrame(rafRef.current);
      clearInterval(stepTimerRef.current);
      setTimeout(() => {
        setTransition(false);
        setProgress(0);
      }, 300);
      return;
    }

    // Reset state
    setPhraseIndex(0);
    setTransition(true);
    setProgress(100);
    // startedAtRef.current = performance.now();

    // Rotate loadingPhrases at equal intervals across the total time
    stepTimerRef.current = setInterval(() => {
      setPhraseIndex((i) => {
        const next = i + 1;
        return next >= loadingPhrases.length ? loadingPhrases.length - 1 : next;
      });
    }, stepMs);

    // // Smooth progress via rAF (based on elapsed time)
    // const tick = (now) => {
    //   const elapsed = now - startedAtRef.current;
    //   const pct = (elapsed / loadingTime) * 100;
    //   // Keep a little headroom so it doesn't hit 100% before aiLoading flips false
    //   const capped = clamp(pct, 0, 100);
    //   setProgress(capped);
    //   rafRef.current = requestAnimationFrame(tick);
    // };
    // rafRef.current = requestAnimationFrame(tick);

    // Cleanup on unmount or when aiLoading flips
    return () => {
      // cancelAnimationFrame(rafRef.current);
      clearInterval(stepTimerRef.current);
    };
  }, [aiLoading]);

  const visualizerType = getCommonVisualizerType();
  const translates = visualizerType === "bathroom" ? loadingPhrasesBathroom : loadingPhrases;

  return (
    <div className={"flex flex-col u-gap-025 u-pb-05 u-pl-05 u-pr-05 u-pt-025 u-rounded-1 " + (className || "")}>
      <div className={"font--12 u-leading-1 text-center" + (language === "en-US" ? " nowrap" : "")}>
        <FormattedMessage id={"look.ai.loading." + translates[phraseIndex]} values={{
          visualizerType: (intl.formatMessage({id: "rooms." + visualizerType})).toLowerCase(),
        }} defaultMessage="Loading…" />…
      </div>
      {/* Progress bar */}
      <div
        className="u-h-05 u-w-full u-rounded-025 overflow-hidden bg-white border border-primary"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        // aria-valuenow={Math.round(progress)}
        aria-label="Loading progress"
        // title={`${Math.round(progress)}%`}
        style={{
          background: "rgba(255, 255, 255, 0.8)",
        }}>
        <div className="u-h-full bg-primary border border-primary u-rounded-025" style={{
          width: `${progress}%`,
          transitionDuration: loadingTime + "ms",
          transitionTimingFunction: "ease-out",
          transitionProperty: transition ? "width" : "none",
          // border: "1px solid rgba(0, 0, 0, 0.8)"
        }}/>
      </div>
      {/*<div className="font--11 opacity-80">{Math.round(progress)}%</div>*/}
    </div>
  );
}


const mapStateToProps = (store) => {
  const {aiLoading} = store.aiState;
  const {language} = store.serverState;
  return {
    aiLoading,
    language,
  };
};

export default injectIntl(
  connect(mapStateToProps)(LookAILoadingBar)
)
